<template>
	<div>
		<div class="q-pt-md flex justify-center items-center container-activity" style="margin: 0 auto">
			<q-btn
				style="padding: 10px"
				color="primary q-mt-lg"
				:label="$t('join_webinar')"
				icon-right="fal fa-external-link"
				@click="open(activity.embed)"
			/>
		</div>

		<q-dialog v-model="show_webinar_dialog" persistent>
			<q-card>
				<q-card-section>
					<div class="text-h6">{{ $t('window_blocked') }}</div>
				</q-card-section>

				<q-card-section class="q-pt-none">
					{{ $t('browser_window_blocked_click') }}
					<a
						style="color: blue"
						:href="activity && activity.embed ? activity.embed : null"
						target="_blank"
						rel="noopener noreferrer"
						>{{ $t('here') }}</a
					>
					{{ $t('to_access_the_class') }}
				</q-card-section>

				<q-card-actions align="right">
					<q-btn flat label="OK" color="primary" v-close-popup />
				</q-card-actions>
			</q-card>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'WebinarExternalLinkPlayer',

	props: ['activity'],

	data() {
		return {
			options: {
				autoplay: true,
			},
			embed: null,
			show_webinar_dialog: false,
		}
	},

	methods: {
		open(embed) {
			this.webinar_external_url = embed
			let webinar = window.open(this.webinar_external_url, '_blank')
			if (webinar === null) this.show_webinar_dialog = true
		},
	},

	created() {
		this.$emit('startWebinar', this.activity)
	},

	beforeDestroy() {
		this.$mitt.emit('setUserOfflineFirebase', this.activity)
	},
}
</script>

<style lang="scss" scoped>
.container-activity {
	width: 70%;
	height: 60vh;
}
</style>
